import {
    faUserTie,
    faDatabase,
    faCalculator,
    faHandshake,
    faUserPlus,
    faBoxes,
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface PLAPP {
  key?: string;
  name?: string;
  icon?: IconDefinition;
  port?: number;
  apiPort?: number;
  color?: string;
  url?: string;
  apiUrl?: string;
  startDate?:string; 
  status?:string
}
  
export const plAppConfig = [
    {
        key: 'accounts',
        name: 'Accounts',
        icon: faUserTie,
        port: 3000,
        apiPort: 8000,
        color: '#1E90FF', // DodgerBlue
        startDate:"01-May-2025",
        status:"80-90% Completed"
    },
    {
        key: 'finance',
        name: 'Finance',
        icon: faCalculator,
        port: 3002,
        apiPort: 4002,
        color: '#8A2BE2', // BlueViolet
        status:"10-20% Completed"
    },
    {
        key: 'masters',
        name: 'Master Data',
        icon: faDatabase,
        port: 3002,
        apiPort: 4003,
        color: '#6A5ACD', // SlateBlue
    },
    {
        key: 'vendor',
        name: 'Vendor',
        icon: faHandshake,
        port: 3004,
        apiPort: 4004,
        color: '#20B2AA', // LightSeaGreen
    },
    {
        key: 'inventory',
        name: 'Inventory',
        icon: faBoxes,
        port: 3005,
        apiPort: 4005,
        color: '#FF6347', // Tomato
    },
    {
        key: 'leads',
        name: 'Leads',
        icon: faUserPlus,
        port: 3006,
        apiPort: 4006,
        color: '#32CD32', // LimeGreen
    },
];

 
